
import React from 'react';
import './Footer.css';
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter, FaEnvelope, FaPhone, FaMapMarkerAlt, FaClock } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleSocialClick = (platform) => {
   
    const socialUrls = {
      facebook: 'https://www.facebook.com/share/1GDThD5BBY/?mibextid=wwXIfr',
      instagram: 'https://www.instagram.com/infosfera.lda?igsh=MWczMDZ0emYybHFoZQ==',
      linkedin: 'https://linkedin.com/company/infosfera',
      twitter: 'https://twitter.com/infosfera'
    };
    
   const url = socialUrls[platform];
  if (url) {
    window.open(url, "_blank"); 
  }
};

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* About Section - More Condensed */}
          <div className="footer-section">
            <h3>Sobre Nós</h3>
            <p>Soluções digitais inovadoras para impulsionar seu negócio através da tecnologia.</p>
            <div className="quick-links">
              <a href="#services">Serviços</a>
              <a href="#portfolio">Portfólio</a>
              <a href="#privacy">Privacidade</a>
            </div>
          </div>
          
          {/* Compact Contact Section */}
          <div className="footer-section">
            <h3>Contato</h3>
           
            <div className="contact-inf">
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <a href="mailto:info@infosfera.co.mz">info@infosfera.co.mz</a>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <span>Maputo, Bairro da Polana Cemeto Av. Maguiguane</span>
              </div>
              <div className="contact-item">
                <FaClock className="contact-icon" />
                <span>Seg-Sex: 8h-17h</span>
              </div>
            </div>
          </div>
          
          {/* Compact Social Section */}
          <div className="footer-section">
            <h3>Conecte-se Conosco</h3>
            <p className="social-description">Siga-nos para novidades e dicas tecnológicas</p>
            <div className="social-icons">
              <button 
                className="social-icon facebook" 
                onClick={() => handleSocialClick('facebook')}
                aria-label="Facebook"
              >
                <FaFacebook />
              </button>
              <button 
                className="social-icon instagram" 
                onClick={() => handleSocialClick('instagram')}
                aria-label="Instagram"
              >
                <FaInstagram />
              </button>
              <button 
                className="social-icon linkedin" 
                onClick={() => handleSocialClick('linkedin')}
                aria-label="LinkedIn"
              >
                <FaLinkedin />
              </button>
              <button 
                className="social-icon twitter" 
                onClick={() => handleSocialClick('twitter')}
                aria-label="Twitter"
              >
                <FaTwitter />
              </button>
            </div>
          </div>
        </div>
      
        {/* Compact Footer Bottom */}
        <div className="footer-bottom">
    
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Infosfera. Todos os direitos reservados.</p>
            <div className="footer-links">
              <a href="#terms">Termos de Uso</a>
              <span className="separator">|</span>
              <a href="#privacy">Política de Privacidade</a>
              <span className="separator">|</span>
              <a href="#cookies">Cookies</a>
            </div>
        </div>
        </div>
        {/* Simple Copyright 
        <div className="footer-bottom">
          <p>&copy; {currentYear} Infosfera. Todos os direitos reservados.</p>
        </div>*/}
      </div>
    </footer>
  );
};

export default Footer;